import { compKey } from './key';
export var createSelectorButtonDriver = function (wrapper) {
    var base = wrapper.$("." + compKey);
    return {
        click: function () { return base.click(); },
        getTitle: function () { return base.$('.title').text(); },
        getSelectedItem: function () { return base.$('.selector-button .selected-item').text(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map